import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

import { NavigationHeaderItem } from 'app/shared/models/common.models';

@Component({
    selector: 'app-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatButtonModule, RouterLink]
})
export class NavigationMenuComponent {
	@Input() navItem: NavigationHeaderItem;
	constructor() {}
}
